import { isNull, keys } from 'lodash';
// Import Constants
import { ErrorShowType, l, TemplateInputTypes } from 'constants/common';
// Import Services
import { TemplateSymbolsCountFields, HooryTemplateConfig } from 'services/template';

const buttonTextInputScenario = (value = { text: '', url: '' }) => ({
    isValid: true,
    errorText: '',
    value: { text: value?.text, url: value?.url },
    paramValue: '',
    type: ErrorShowType.Default,
    validationCredentials: [
        {
            ValidationType: 'viberButtonText',
            ErrorMessage: l.CannotBeEmpty,
            ParametersValues: null,
        },
        {
            ValidationType: 'viberButtonTextMaxLength',
            ErrorMessage: l.MustContainMaximumCharacters,
            ParametersValues: '30',
        },
    ],
});

const buttonUrlInputScenario = (value = { text: '', url: '' }) => ({
    isValid: true,
    errorText: '',
    value: { text: value?.text, url: value?.url },
    paramValue: '',
    type: ErrorShowType.Default,
    validationCredentials: [
        {
            ValidationType: 'isUrlValidOrEmptyString',
            ErrorMessage: l.EnterValidUrl,
            ParametersValues: null,
        },
        {
            ValidationType: 'viberButtonUrl',
            ErrorMessage: l.CannotBeEmpty,
            ParametersValues: null,
        },
    ],
});

const bodyScenario = (state) => ({
    isValid: null,
    errorText: '',
    value: '',
    paramValue: '',
    type: ErrorShowType.Default,
    validationCredentials: [
        {
            ValidationType: 'required',
            ErrorMessage: l.CannotBeEmpty,
            ParametersValues: null,
        },
        {
            ValidationType: 'maxLengthWithRegEx',
            ErrorMessage: l.MustContainMaximumCharacters,
            ParametersValues: { ...state, fieldName: 'Body', count: TemplateSymbolsCountFields.Hoory },
        },
    ],
});

const subjectScenario = () => ({
    isValid: null,
    errorText: '',
    value: '',
    paramValue: '',
    type: ErrorShowType.Default,
    validationCredentials: [
        {
            ValidationType: 'required',
            ErrorMessage: l.CannotBeEmpty,
            ParametersValues: null,
        },
        {
            ValidationType: 'minLength',
            ErrorMessage: l.MustContainMinimumCharacters,
            ParametersValues: '2',
        },
        {
            ValidationType: 'maxLength',
            ErrorMessage: l.MustContainMaximumCharacters,
            ParametersValues: '100',
        },
    ],
});

const validityPeriodScenario = () => ({
    isValid: null,
    errorText: '',
    value: HooryTemplateConfig.DefaultValidityPeriodInMinutes,
    paramValue: '',
    type: ErrorShowType.Default,
    validationCredentials: [
        {
            ValidationType: 'required',
            ErrorMessage: l.CannotBeEmpty,
            ParametersValues: null,
        },
        {
            ValidationType: 'lessThanOrEqual',
            ErrorMessage: l.MustBeSmallerOrEqualThan,
            ParametersValues: HooryTemplateConfig.MaxValidityPeriodInMinutes,
        },
        {
            ValidationType: 'greaterThanOrEqual',
            ErrorMessage: l.MustBeBiggerOrEqualThan,
            ParametersValues: HooryTemplateConfig.MinValidityPeriodInMinutes,
        },
    ],
});

const hooryTemplateValidationScenario = (state) => ({
    Name: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.CannotBeEmpty,
                ParametersValues: null,
            },
            {
                ValidationType: 'firstSymbol',
                ErrorMessage: l.NameFirstCharacterCantBeASymbol,
                ParametersValues: /^[\p{L}0-9]/gu,
            },
            {
                ValidationType: 'minLength',
                ErrorMessage: l.MustContainMinimumCharacters,
                ParametersValues: '3',
            },
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '50',
            },
        ],
    },
    Description: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '250',
            },
        ],
    },
    CrossValidation: {
        isValid: null,
        errorText: '',
        value: {},
        type: ErrorShowType.Toaster,
        validationCredentials: [
            {
                ValidationType: 'templateCrossValidation',
                ErrorMessage: '',
                ParametersValues: [TemplateInputTypes.Body, TemplateInputTypes.Subject],
            },
        ],
    },
    ForbiddenDynamicVariables: {
        isValid: null,
        errorText: '',
        value: {},
        type: ErrorShowType.Toaster,
        validationCredentials: [
            {
                ValidationType: 'templateForbiddenDynamicVariables',
                ErrorMessage: '',
                ParametersValues: [TemplateInputTypes.Body],
            },
        ],
    },
    defaultLangButtonText: {
        ...buttonTextInputScenario(),
    },
    defaultLangButtonUrl: {
        ...buttonUrlInputScenario(),
    },
    defaultLangBody: { ...bodyScenario(state) },
    defaultLangSubject: { ...subjectScenario() },
    defaultLangValidityPeriod: { ...validityPeriodScenario() },
});

const hooryTemplateScenarioPropertiesCreator = (data, editCloneMode, state) => {
    if (editCloneMode) {
        return keys(data).reduce((acc, id) => {
            acc[`${id}Body`] = {
                ...bodyScenario(state),
                isValid: isNull(data[id].isValid) ? null : true,
                value: data[id].Body,
            };
            acc[`${id}Subject`] = {
                ...subjectScenario(),
                isValid: isNull(data[id].isValid) ? null : true,
                value: data[id].Subject,
            };
            acc[`${id}ValidityPeriod`] = {
                ...validityPeriodScenario(),
                isValid: isNull(data[id].isValid) ? null : true,
                value: data[id].ValidityPeriod,
            };
            acc[`${id}ButtonText`] = {
                ...buttonTextInputScenario({ text: data[id].ButtonText, url: data[id].ButtonUrl }),
                isValid: isNull(data[id].isValid) ? null : true,
            };
            acc[`${id}ButtonUrl`] = {
                ...buttonUrlInputScenario({ text: data[id].ButtonText, url: data[id].ButtonUrl }),
                isValid: isNull(data[id].isValid) ? null : true,
            };

            return acc;
        }, {});
    }

    return data.reduce((acc, id) => {
        acc[`${id}Body`] = { ...bodyScenario(state) };
        acc[`${id}Subject`] = { ...subjectScenario() };
        acc[`${id}ValidityPeriod`] = { ...validityPeriodScenario() };
        acc[`${id}ButtonText`] = { ...buttonTextInputScenario() };
        acc[`${id}ButtonUrl`] = { ...buttonUrlInputScenario() };

        return acc;
    }, {});
};

export { hooryTemplateValidationScenario, hooryTemplateScenarioPropertiesCreator };
